/**
 * Active CommandBus + LiveKit Room references for the current session,
 * lifted into a Zustand store so components OUTSIDE the LiveKitRoom
 * (e.g. SessionPage's sidebar buttons) can publish envelopes too.
 *
 * The store is populated by `InRoomAnnotation` on mount and cleared on
 * unmount so the references match the connected room exactly. Any
 * component that needs to broadcast `system/session.ended` or
 * `system/recording.started` from outside the LiveKit context reads
 * `useSessionBus(s => s.bus)`.
 */
import type { Room } from "livekit-client";
import { create } from "zustand";

import type { CommandBus } from "./commandBus";

type Store = {
  bus: CommandBus | null;
  room: Room | null;
  setBus: (bus: CommandBus | null, room: Room | null) => void;
};

export const useSessionBus = create<Store>((set) => ({
  bus: null,
  room: null,
  setBus: (bus, room) => set({ bus, room }),
}));